<template>
  <div :class="classObj" class="app-wrapper">
    <!--<div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />-->
    <sidebar :class="['sidebar-container', {'sidebar-pos': hShow}]" />
    <div class="main-container">
      <div v-if="hShow" :class="[{'fixed-header':fixedHeader}, {'header-width': hShow}]">
        <div class="fixed-header-wrapper">
          <div class="header-title">{{ $t('common.member') }}</div>
          <!--          <img v-if="!$route.query.from" class="close-btn" src="@/assets/icon-close.png" alt="" @click.self="closePage">-->
        </div>
      </div>
      <div v-if="!hShow" :class="{'fixed-header':fixedHeader}">
        <navbar />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: false,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    hShow() {
      return this.$route.query.hShow
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    closePage() {
      window.close()
    }
  }
}
</script>

<style lang="scss" scoped>

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    //overflow: hidden;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
    .sidebar-pos {
      padding-top: 10px;
      top: 50px;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .header-width {
    width: 100%;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
  .fixed-logo-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    width:162px;
    height:48px;
    background:rgba(44,59,78,1);
    display: flex;
    .sidebar-logo{
      width: 86px;
      height: 42px;
      margin: auto;
    }
  }
  .main-container{
    top: 48px !important;
    &.no-sider{
      margin-left: 0!important;
    }
  }
</style>
